/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Expected_CloseInputs */

const cs_order_expected_close = /** @type {(inputs: Order_Expected_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Očekávané uzavření`)
};

const en_order_expected_close = /** @type {(inputs: Order_Expected_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expected close`)
};

/**
* | output |
* | --- |
* | "Expected close" |
*
* @param {Order_Expected_CloseInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const order_expected_close = /** @type {((inputs?: Order_Expected_CloseInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Expected_CloseInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_order_expected_close(inputs)
	return cs_order_expected_close(inputs)
});